module.exports = __webpack_public_path__ + "img/devday-1.ccbd2ac9.jpg";